const KEY = 'ai.referralCode';
const CODE_PATTERN = /^[A-Za-z0-9]{4,16}$/;

/** Keeps `?ref=` from an invite link until the user has an account (survives login redirects). */
export function captureReferralFromUrl(): void {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref && CODE_PATTERN.test(ref)) localStorage.setItem(KEY, ref.toUpperCase());
  } catch {
    // Storage unavailable (private mode): the user can still type the code manually.
  }
}

export function getStoredReferral(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearStoredReferral(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
